export const PermissionsServiceTokens = Object.freeze({
    RouterAdapter: 'RouterAdapter',
    UserProfileProvider: 'UserProfileProvider',
} as const);
